import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Typography, Box } from "@curves/ui-base";
import PrivacyDataToggle from "@icoach/components/PrivacyDataToggle";
import { MemberAvatar } from "@icoach/components/infoCard/";
import InfoCard from "@icoach/components/infoCard/InfoCard";
import { isFunction } from "@util/utils";

export const MemberSecureBox = ({
	className,
	avatar,
	avatarWidth = "5.5",
	targetID,
	name,
	maskName,
	nickname,
	memberNo,
	phone,
	maskPhone,
	link,
	membershipStatus,
	onClick,
	isShowAvatar = true,
	isRevealed,
	toggle,
	...others
}) => {
	const handleOnClick = () => {
		if (isFunction(onClick)) onClick();
	};

	return (
		<InfoCard className={clsx("member-info-card", className)} link={link} onClick={handleOnClick} {...others}>
			{isShowAvatar && <MemberAvatar className={"member-info-card__avatar"} src={avatar} width={avatarWidth} membershipStatus={membershipStatus} alt={name} />}
			<Box className={"member-info-card__content"}>
				<PrivacyDataToggle fullData={name} maskedData={maskName} isRevealed={isRevealed} onToggle={toggle} />
				{nickname && (
					<Typography className={"member-info-card__nickname"} title={nickname}>
						{nickname}
					</Typography>
				)}
				{memberNo && (
					<Typography className={"member-info-card__member-number"} title={memberNo}>
						{memberNo}
					</Typography>
				)}
				{phone && <PrivacyDataToggle fullData={phone} maskedData={maskPhone} isRevealed={isRevealed} onToggle={toggle} />}
			</Box>
		</InfoCard>
	);
};

MemberSecureBox.prototype = {
	className: PropTypes.string,
	avatar: PropTypes.string,
	avatarWidth: PropTypes.string,
	name: PropTypes.string.isRequired,
	maskName: PropTypes.string,
	nickname: PropTypes.string,
	memberNo: PropTypes.string,
	phone: PropTypes.string,
	link: PropTypes.string,
	membershipStatus: PropTypes.number,
	onClick: PropTypes.func,
	isShowAvatar: PropTypes.bool,
};

export default MemberSecureBox;
